import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSidebar } from '../../contexts/SidebarContext';

const Layout = ({ children }) => {
  const { isOpen, toggle, close } = useSidebar();

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar - fixo na lateral */}
      <Sidebar isOpen={isOpen} onClose={close} />
      
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header - ocupa toda a largura disponível */}
        <Header onMenuClick={toggle} />
        
        {/* Page content - com margem apenas no conteúdo */}
        <main className={`flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 transition-all duration-300 ${isOpen ? 'lg:ml-48' : ''}`}>
          <div className={`py-8 ${isOpen ? 'lg:pl-0 lg:pr-12 px-6' : 'px-12'}`}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
